import {loadScript} from "@/utils/http";

const loadSAH = async (dependency, contents) => {
    const {url, target} = dependency.source;

    // if source of the library already in cache do nothing
    let data = loadSAH.cache[dependency.id];
    if (!data) {
        // load the data from the source
        await loadScript({url});

        // retrieve the target from the loaded data
        data = window[target];
        delete window[target];

        // put in cache
        loadSAH.cache[dependency.id] = data;
    }

    // if not already present, create a library context in global
    const library = (window[dependency.id] = window[dependency.id] || {});

    // for each content specified, load it and put it inside the library context
    for (const reference of contents) {
        // if the content is already loaded, do nothing
        if (library[reference]) {
            continue;
        }

        // in case of our SAH libraries, we exposes the content via lazy loading to avoid loading too much
        // things so we need to call our content and wait to retrieve it
        if (!data[reference]) {
            throw Error(`Content ${reference} of dependency ${dependency.id} not available`);
        }

        // load content of the library
        const content = await data[reference]();

        // handle cases where it is a default export or normal export
        let resolvedContent = content;
        if (content.default) {
            // default export has been used,
            resolvedContent = content.default;
        }

        // store content
        library[reference] = resolvedContent;
    }

    // now the code should be available via import in other apps declaring <dependency.id> as external
    // import {<content>} from "<dependency.id>";
};
loadSAH.cache = {};

export default loadSAH;
